<div class="bg-dark text-light fw-bold d-flex align-items-center px-2 py-1 lh-1">
  <span class="material-icons pe-1"> local_police </span>

  <span>{{ 'admin' | translate | uppercase }} </span>
</div>
